import React from 'react';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';
import { styles } from './PerksBenefit.css';

export type PerksBenefitProps = {
  heading: string;
  content: string;
  icon?: JSX.Element;
  isSmall?: boolean;
  isDomCasual?: boolean;
  enabled?: boolean;
};

export const PerksBenefit = ({ heading, content, icon, isDomCasual }: PerksBenefitProps): JSX.Element => {
  return (
    <div className={styles.root}>
      {icon ? <div className={styles.icon}>{icon}</div> : null}
      <div className={styles.content}>
        {isDomCasual ? (
          <CalloutFont as="h5">{heading}</CalloutFont>
        ) : (
          <p>
            <strong>{heading}</strong>
          </p>
        )}
        {content ? <p>{content}</p> : null}
      </div>
    </div>
  );
};
